import Layout from '@/components/layouts'
import Theme from '@/components/template/Theme'
import { Buffer } from 'buffer'
import process from 'process'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import './locales'
import store, { persistor } from './store'
// const environment = process.env.NODE_ENV

// /**
//  * Set enableMock(Default false) to true at configs/app.config.js
//  * If you wish to enable mock api
//  */
// if (environment !== 'production' && appConfig.enableMock) {
//     mockServer({ environment })
// }

// Polyfill global object
;(window as any).global = window
// Polyfill Buffer
;(window as any).Buffer = Buffer
// Polyfill process
;(window as any).process = process
function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <Theme>
                        <Layout />
                    </Theme>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
